import type { CoachingSession, CoachProfile } from '@efdigital/ll-addon-data';
import SessionCard from '@efdigital/ll-xceed-v2/components/coaching/coachee/session-card.gts';
import type { CoachingCoacheeCohortSessionsIndexModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/sessions/index';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortSessionsIndexSignature {
  Args: {
    model: CoachingCoacheeCohortSessionsIndexModel;
    controller: unknown;
  };
}

function lookupCoach(
  coachUserId: string,
  coaches: CoachProfile[]
): CoachProfile | undefined {
  return coaches.find((coach) => coach.user === coachUserId);
}

function hasAny(...sessionsArrays: CoachingSession[][]) {
  return sessionsArrays.some((sessions) => sessions.length > 0);
}

<template>
  {{pageTitle "Sessions"}}

  <div class="container my-3">
    {{#if (hasAny @model.upcoming @model.needsAttention)}}
      {{#if @model.upcoming.length}}
        <div class="mb-4">
          <h3 class="gud-eyebrow">Upcoming</h3>
          {{#each @model.upcoming as |session|}}
            {{#let (lookupCoach session.coachUserId @model.coaches) as |coach|}}
              {{#if coach}}
                <SessionCard
                  @session={{session}}
                  @coach={{coach}}
                  @coachingConfig={{@model.coachingConfig}}
                  @planner={{@model.planner}}
                  class="mb-2"
                />
              {{/if}}
            {{/let}}
          {{/each}}
        </div>
      {{/if}}

      {{#if @model.needsAttention.length}}
        <div class="mb-4">
          <h3 class="gud-eyebrow">Attention needed</h3>
          {{#each @model.needsAttention as |session|}}
            {{#let (lookupCoach session.coachUserId @model.coaches) as |coach|}}
              {{#if coach}}
                <SessionCard
                  @session={{session}}
                  @coach={{coach}}
                  @coachingConfig={{@model.coachingConfig}}
                  @planner={{@model.planner}}
                  class="mb-2"
                />
              {{/if}}
            {{/let}}
          {{/each}}
        </div>
      {{/if}}
    {{else}}
      <div class="alert alert-primary">
        <p class="mb-0">You have no upcoming sessions.</p>
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<CoachingCoacheeCohortSessionsIndexSignature>;
